const PageColumnContainer = ({ children }) => (
  <div className="flex flex-col sm:flex-row justify-center sm:space-x-12 md:space-x-20 text-lightGray-1">
    {children}
  </div>
);

export default PageColumnContainer;
